import { useFormContext } from 'react-hook-form';
import { FfcChildProps, getFieldErrors } from '../shared';
import { FormEditorForm } from '../../../shared';
import FieldTitle from './FieldTitle';
import FieldHelpText from './FieldHelpText';
import RequiredSwitch from './RequiredSwitch';
import FieldConfigurationWrapper from './FieldConfigurationWrapper';
import MultiSwitch from './MultiSwitch';
import FieldOptionLst from './FieldOptionLst';

const DropdownFieldConfiguration = ({ fieldIndex }: FfcChildProps) => {
  const { control, formState } = useFormContext<FormEditorForm>();
  const { label: titleError, helptext: descriptionError } = getFieldErrors(formState.errors.fields, fieldIndex);

  return (
    <FieldConfigurationWrapper>
      <FieldTitle control={control} fieldIndex={fieldIndex} error={titleError} />
      <FieldHelpText control={control} fieldIndex={fieldIndex} error={descriptionError} />
      <FieldOptionLst fieldIndex={fieldIndex} control={control} />
      <MultiSwitch control={control} fieldIndex={fieldIndex} />
      <RequiredSwitch control={control} fieldIndex={fieldIndex} />
    </FieldConfigurationWrapper>
  );
};

export default DropdownFieldConfiguration;
